import DOMPurify from 'dompurify';

export const sanitizeHtml = (html) => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br'],
    ALLOWED_ATTR: []
  });
};

export const escapeHtml = (text) => {
  if (typeof text !== 'string') return text;

  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
};

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;

  return input
    .replace(/[<>]/g, '')
    .trim()
    .substring(0, 1000); // Limit length
};

export const validateImageUrl = (url) => {
  if (!url) return false;

  const allowedDomains = [
    window.location.hostname,
    'localhost',
    '127.0.0.1'
  ];

  try {
    const urlObj = new URL(url, window.location.origin);
    return allowedDomains.includes(urlObj.hostname);
  } catch {
    return false;
  }
};